import { Request as BaseRequest, Utils } from 'grt-web-components';
import { baseURL, previewDocUrl, bucketName } from '@/httpService/API';

export type { RequestResult } from 'grt-web-components';
export const obsSignUrl: string = baseURL + '/grt-user-center-service/open/aliyun/oss/v1/temp/url',
    fileList: string = 'document/page/search',
    fileDetail: string = 'document/',
    fileUpdate: string = 'document',
    fileDelete: string = 'document/',
    fileSave: string = 'document/create-batch',
    fileDeleteMultiple: string = '/document',
    categorySort: string = 'category/sort',
    categoryUpdate: string = 'category',
    categorySave: string = 'category',
    categoryDelete: string = 'category/',
    categoryDetail: string = 'category/',
    categoryChildren: string = 'category/children/',
    categoryTree: string = 'category/tree',
    checkFile: string = 'document/check',
    relList: string = 'document/relation/course/search',
    aiDetail: string = 'transcription/getCourseTransInfo',
    addKeyword: string = 'transcription/addLabResult',
    delKeyword: string = 'transcription/delLabResult',
    modifySummary: string = 'transcription/modLabResult',
    modifyTab: string = 'transcription/modMoreLabResult',
    modifyAllContent: string = 'transcription/saveTransDocResult',
    ossUploadCallbackUrl: string = 'transcription/ossCallback',
    examineList: string = 'admin/discuss/page/search';

export class Request extends BaseRequest {
    constructor() {
        super();
    }

    static baseUrl: string = baseURL + '/grt-resource-manage-service/';
    static baseUrlOpenAi: string = baseURL + '/grt-resource-manage-ai/';
    static examineUrl: string = baseURL + '/grt-bbs-service/';

    static getBucketName(type): string {
        if (type === 2 || type === 21) return bucketName['video'];
        else if (type === 3) return bucketName['audio'];
        return bucketName['other'];
    }

    static getOssBucketName() {
        return bucketName['oss'];
    }

    static getBbsBucketName() {
        return bucketName['other'];
    }
}

export const previewUrl = previewDocUrl;
export default Utils;
